import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowUpRight, Home } from 'lucide-react';
import CSatSurveyModal from '../components/CSatSurveyModal';

export default function Feedback() {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(true);

  const handleClose = () => {
    setModalOpen(false);
    // Brief delay so the user sees the underlying page before being routed away
    setTimeout(() => navigate('/our-work'), 250);
  };

  return (
    <main className="min-h-screen relative" data-testid="feedback-page" data-nav-theme="dark">
      {/* Sticky branded bar — sits ABOVE the modal so visitors can always reach the website */}
      <div className="fixed top-0 left-0 right-0 z-[120] bg-[var(--ink)]/95 backdrop-blur-xl border-b border-white/10">
        <div className="max-w-[1500px] mx-auto px-6 md:px-10 lg:px-14 h-[72px] flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3 group" data-testid="feedback-logo-link">
            <img src="/logos/full.png" alt="Tricolite Energy Solutions" className="h-9 md:h-10 w-auto select-none"/>
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/10 hover:bg-[var(--orange)] border border-white/20 hover:border-[var(--orange)] text-white text-[13px] font-medium transition-colors" data-testid="feedback-visit-site">
            <Home className="w-4 h-4"/> Visit Tricolite Website <ArrowUpRight className="w-3.5 h-3.5"/>
          </Link>
        </div>
      </div>

      {/* Branded backdrop */}
      <div className="absolute inset-0 bg-[var(--ink)]"/>
      <div className="absolute inset-0 grid-bg-dark opacity-40 pointer-events-none"/>
      <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-[var(--orange)]/12 blur-3xl pointer-events-none"/>
      <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-[var(--blue)]/10 blur-3xl pointer-events-none"/>

      <div className="relative max-w-[1500px] mx-auto px-6 md:px-10 lg:px-14 pt-40 pb-24 text-white">
        <div className="text-[11px] uppercase tracking-[0.28em] text-[var(--orange)] font-semibold mb-4">Customer Feedback</div>
        <h1 className="font-display text-[clamp(34px,4.6vw,62px)] leading-[1.05] font-bold tracking-tight max-w-3xl">
          Tell us how we&apos;re <span className="font-serif-it text-[var(--orange)]">really</span> doing.
        </h1>
        <p className="mt-6 max-w-2xl text-[15px] md:text-[17px] text-white/70 leading-[1.85]">
          Your honest, candid rating helps the TES leadership review every project we deliver. It takes about two minutes.
        </p>

        {/* When modal is closed, show explore CTAs so visitors don't bounce */}
        {!modalOpen && (
          <div className="mt-10 flex flex-wrap items-center gap-3">
            <button onClick={() => setModalOpen(true)} className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[var(--orange)] hover:bg-[var(--orange-soft)] text-white font-medium transition-colors" data-testid="reopen-csat">
              Open the survey again
            </button>
            <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/10 hover:bg-white/20 border border-white/20 text-white transition-colors">Visit Homepage <ArrowUpRight className="w-4 h-4"/></Link>
            <Link to="/our-work" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/10 hover:bg-white/20 border border-white/20 text-white transition-colors">See Our Work <ArrowUpRight className="w-4 h-4"/></Link>
          </div>
        )}
      </div>

      <CSatSurveyModal open={modalOpen} onClose={handleClose} />
    </main>
  );
}
